var getUrlParas = function(url) {
	/*返回字符串后参数对象，url不传默认为当前url*/
    let searchStr,
        props = {}
    if (!url) {
        url = window.location.href
    }
    searchStr = url.split('?')[1]
    if (searchStr && typeof searchStr === 'string') {
        searchStr.split('&').forEach(function(item, index) {
            props[item.split('=')[0]] = item.split('=')[1]
            if (index === searchStr.split('&').length - 1) {
                props[item.split('=')[0]] = item.split('=')[1].replace(/#[\s\S]*/, '')
            }
        })
    }
    return props
}

export default getUrlParas
